/* @ngInject */
export default function ParametricSearchService($location, $translate, SleuthService, SpinnerLoadingService) {
    function searchParameterValuesBySleuth(parameterValueIds) {
        SpinnerLoadingService.showLoading();

        if (!Array.isArray(parameterValueIds)) {
            parameterValueIds = [parameterValueIds];
        }
        const queryParameterValues = {
            targetMfgs: [],
            targetDefinitionIds: [],
            values: [],
            parameterValueIds: parameterValueIds
        };

        if ($location.search().id) {
            if (Array.isArray($location.search().id)) {
                queryParameterValues.targetDefinitionIds = $location.search().id;
            } else {
                queryParameterValues.targetDefinitionIds.push($location.search().id);
            }
        }
        parameterValueIds.forEach(function (parameterValueId) {
            const queryParameterValue = {
                parameterValueIds: [parameterValueId],
                oldParameterValueIds: [parameterValueId]
            };
            queryParameterValues.values.push(queryParameterValue);
        });

        SleuthService.executeParameterValueSearchByQuery(queryParameterValues, function () {
            SpinnerLoadingService.hideLoading();
        });
    }

    function searchParameterValuesAndDefBySleuth(parameterValueIds, defIds, queryType) {
        SpinnerLoadingService.showLoading();

        if (!Array.isArray(parameterValueIds)) {
            parameterValueIds = [parameterValueIds];
        }
        const queryParameterValues = {
            targetMfgs: [],
            targetDefinitionIds: [],
            values: [],
            parameterValueIds: parameterValueIds
        };
        if (!Array.isArray(defIds)) {
            queryParameterValues.targetDefinitionIds.push(defIds);
        } else {
            queryParameterValues.targetDefinitionIds = queryParameterValues.targetDefinitionIds.concat(defIds)
        }
        parameterValueIds.forEach(function (parameterValueId) {
            const queryParameterValue = {
                parameterValueIds: [parameterValueId],
                oldParameterValueIds: [parameterValueId]
            };
            queryParameterValues.values.push(queryParameterValue);
        });

        SleuthService.executeParameterValueSearchByQuery(queryParameterValues, function () {
            SpinnerLoadingService.hideLoading();
        }, queryType);
    }

    return {
        searchParameterValuesBySleuth: searchParameterValuesBySleuth,
        searchParameterValuesAndDefBySleuth: searchParameterValuesAndDefBySleuth
    };
}

